import Text from "common/values/text/text";

export default class ProjectName extends Text {
  public override clone(): ProjectName {
    return new ProjectName(this.value);
  }

  public static get Prototype(): ProjectName {
    return new ProjectName('Prototype');
  }

  public get isEmpty(): boolean {
    return this.value === '';
  }

  public static fromJSON(value: string): ProjectName {
    return new ProjectName(value);
  }

  public override fromJSON(value: string): ProjectName {
    return ProjectName.fromJSON(value);
  }

  public toJSON(): string {
    return this.value;
  }
}
